//#region IMPORTS
import language from '../../../config/es';
//#endregion IMPORTS

const { filterData } = language.messages;

// Configuracion de los campos de filtro comunes a los monitores parciales
export const FILTER_FIELDS = [
  {
    name: 'clientName',
    flag: 'filterClientName',
    maxLength: 100,
    label: filterData.lblClientName,
    placeholder: filterData.plHolderClientName,
    notifyLabel: filterData.lblClientName,
  },
  {
    name: 'clientCi',
    flag: 'filterClientCi',
    maxLength: 30,
    label: filterData.lblClientCi,
    placeholder: filterData.plHolderClientCi,
    notifyLabel: filterData.lblClientCi,
  },
  {
    name: 'clientCodeSap',
    flag: 'filterClientCodeSap',
    maxLength: 40,
    label: filterData.lblClientCodeSap,
    placeholder: filterData.plHolderClientCodeSap,
    // Se mantiene la etiqueta original usada en la notificacion
    notifyLabel: filterData.lblClientCi,
  },
];

// Estado inicial del filtro
export const createInitialFilter = () => ({
  loadConciliation: false,
  clientName: { value: '', error: '' },
  clientCi: { value: '', error: '' },
  clientCodeSap: { value: '', error: '' },

  errors: [],
  filterClientName: false,
  filterClientCi: false,
  filterClientCodeSap: false,
});

// Formatea una fecha como yyyy-MM-dd
export const getDateFormat = (date) => {
  const startMonth = date.getMonth() + 1 + '';
  const startDay = date.getDate() + '';
  return date.getFullYear() + '-' + startMonth.padStart(2, '0') + '-' + startDay.padStart(2, '0');
};

// Opciones de paginacion de la tabla
export const paginationOptions = {
  rowsPerPageText: language.messages.rowsPerPageText,
  rangeSeparatorText: language.messages.rangeSeparatorText,
  selectAllRowsItem: true,
  selectAllRowsItemText: language.messages.selectAllRowsItemText,
};
